import {
  Component,
  EventEmitter,
  Output,
  Input,
  ChangeDetectionStrategy,
  OnDestroy,
  HostBinding,
  HostListener,
  ElementRef,
  OnInit,
} from '@angular/core'
import {merge, Observable, of, Subject} from 'rxjs'
import {FilterOption, FilterOptions} from '../filter.types'
import {map, skip, take, takeUntil} from 'rxjs/operators'

@Component({
  selector: 'cft-filter-dropdown',
  templateUrl: './filter-dropdown.component.html',
  styleUrls: ['./filter-dropdown.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterDropdownComponent implements OnInit, OnDestroy {
  @Input() option$!: Observable<FilterOptions<unknown>>
  @Input() noOptionsMessage?: string

  @Output() selected = new EventEmitter<FilterOption<unknown>>()
  @Output() keepFocus = new EventEmitter<true>()

  @HostBinding('class.isVisible')
  isVisible = false

  showInitialMessage$!: Observable<boolean>
  skipWhileBubbling = false

  private readonly destroy$ = new Subject<true>()
  readonly value$ = new Subject<FilterOption<unknown>>()

  constructor(private readonly elementRef: ElementRef) {
    this.value$.pipe(takeUntil(this.destroy$)).subscribe(value => this.selected.emit(value))
  }

  ngOnInit() {
    this.showInitialMessage$ = merge(
      of(true),
      this.option$.pipe(
        skip(1),
        take(1),
        map(_ => false),
      ),
    )
  }

  ngOnDestroy() {
    this.destroy$.next(true)
    this.destroy$.complete()
  }

  selectValue(option: FilterOption<unknown>) {
    this.value$.next(option)
    this.hide()
  }

  selectEmpty() {
    this.keepFocus.emit(true)
  }

  @HostListener('window:click', ['$event'])
  outsideClick(event: MouseEvent) {
    if (this.skipWhileBubbling) {
      this.skipWhileBubbling = false
      return
    }

    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.hide()
    }
  }

  show(skipInitialBubbling?: true) {
    if (skipInitialBubbling) {
      this.skipWhileBubbling = skipInitialBubbling
    }
    this.isVisible = true
  }

  hide() {
    this.isVisible = false
  }
}
